import { Card } from 'antd';

import BreedingTable from '../../../components/Breeding';

function Breeding() {
  return (
    <Card>
      <BreedingTable breadcrumb="List of Livestock breeding" title="Livestock breeding" />
    </Card>
  );
}

export default Breeding;
